import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { getControlField } from "../../../../Services/tooltipService";
import { getEmail } from "../../../../Services/tooltipService";
import DataTable from "../../../../Components/UiComponents/DataTable";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import { InputIcon } from "primereact/inputicon";
import { Dialog } from "primereact/dialog";
import { checkEmail, saveEmail, removeExternalUser, updateExternalUser } from "../../../../Services/tooltipService";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearchBar";
import { useNavigate } from "react-router-dom";

const ExternalEmails = () => {
    const [customerId, setCustomerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [controlPanelEmailsTab, setControlPanelEmailsTab] = useState('');
    const [controlPannelEmailsHeaders, setControlPannelEmailsHeaders] = useState([]);
    const [controlEmailTables, setControlEmailTables] = useState([]);
    const [emails, setEmails] = useState([]);
    const [position, setPosition] = useState("center");
    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({
        external_user_name: "",
        external_email: "",
    });
    const toastRef = useRef()
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [surveyEmailData, setSurveyEmailData] = useState("");
    const [surveyEmailDataEdit, setSurveyEmailDataEdit] = useState("");
    const [errors, setErrors] = useState({});
    const [dataToDelete, setDataToDelete] = useState({});
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [emailDataCheck, setEmailDataCheck] = useState("");
    const [userDataCheck, setUserDataCheck] = useState("");
    const [selectedEmail, setSelectedEmail] = useState({});
    const [lazyParams, setLazyParams] = useState({
        first: 0,
    });
    const [searchQuery, setSearchQuery] = useState("");
    const [searchedLength, setSearchedLength] = useState(0);
    const [filterEmailDetails, setFilterEmailDetails] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        const customerData = localStorage.getItem("enduser");
        if (customerData) {
            const customerDataInJSON = JSON.parse(customerData);
            setCustomerId(customerDataInJSON.customer);
        } else {
            navigate("/login")
            localStorage.clear()
        }
    }, []);

    useEffect(() => {
        if (customerId) {
            getControlFieldData();
            getExternalEmail();
        }
    }, [customerId]);

    const getControlFieldData = async () => {
        try {
            if (customerId === null) {
                return;
            }
            var clientModuleData = await getControlField(customerId)
            var controlPanelModules = _.find(clientModuleData?.data?.cust[0].modules, { module_name: "Control Panel", status: true });
            const cntlPannel_Emails = controlPanelModules.tabs.find(
                (tab) => tab.tab_name === "External Emails"
            ).display_name;
            setControlPanelEmailsTab(cntlPannel_Emails)

            var cntlPannelTable_Emails = _.find(controlPanelModules.tabs, { tab_name: "External Emails" }).tables;
            setControlEmailTables(cntlPannelTable_Emails)
            var ControlPannelEmailsHeaders = _.find(cntlPannelTable_Emails, { table_name: "External Emails" }).headers;
            setControlPannelEmailsHeaders(ControlPannelEmailsHeaders)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getExternalEmail = async () => {
        try {
            if (customerId === null) {
                return;
            }
            const response = await getEmail(customerId, formData);
            setEmails(response?.data?.externalUserData)
            setFilterEmailDetails(response?.data?.externalUserData)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0
        });
        filteredQuestionsArray(e.target.value)
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0
        });
        filteredQuestionsArray("");
    };

    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getExternalEmail();
            setSearchedLength(lowerCaseQuery.length); // Update the searched length after resetting the data
        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }

            // Filter the customer reference data if the query is not empty
            const filteredData = filterEmailDetails.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value => {
                    // Convert value to string and to lowercase for comparison
                    if (value != null) {
                        return value.toString().toLowerCase().includes(lowerCaseQuery);
                    }
                });
            });

            // Update the state with the filtered data
            setEmails(filteredData);
        }
    }

    // Regex for email validation
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    // Handle input change with validation
    const handleInputChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value,
        });
        // Validation for external_user_name (minLength 2)
        if (name === "external_user_name") {
            if (value.length < 2) {
                setErrors({ ...errors, [name]: 'Please enter valid username' });
            } else {
                setErrors({ ...errors, [name]: '' }); // Clear error if valid
            }
        }

        // Validation for external_email (pattern and minLength 2)
        if (name === "external_email") {
            if (value.length < 2) {
                setErrors({ ...errors, [name]: 'Please enter valid email id' });
            } else if (!emailPattern.test(value)) {
                setErrors({ ...errors, [name]: 'Please enter valid email id' });
            } else {
                setErrors({ ...errors, [name]: '' }); // Clear error if valid
            }
        }
    };

    const handleEditInputChange = (field, value) => {
        setSelectedEmail({
            ...selectedEmail,
            [field]: value,
        });
        if (field === "external_user_name") {
            if (value.length < 2) {
                setErrors({ ...errors, [field]: 'Please enter valid username' });
            } else {
                setErrors({ ...errors, [field]: '' });
            }
        }

        // Validation for external_email (pattern and minLength 2)
        if (field === "external_email") {
            if (value.length < 2) {
                setErrors({ ...errors, [field]: 'Please enter valid email id' });
            } else if (!emailPattern.test(value)) {
                setErrors({ ...errors, [field]: 'Please enter valid email id' });
            } else {
                setErrors({ ...errors, [field]: '' }); // Clear error if valid
            }
        }
    };

    const openEmailEdit = (open, index, email) => {
        setSelectedEmail(email);
        setIsDialogOpen(open);
    };

    const confirmDeleteProduct = () => {
        setDeleteProductDialog(true);
    };

    const handleCheckboxChange = (index, sub) => {
        const updatedEmails = emails.map((email, i) => {
            if (i === index) {
                return { ...email, checked: !email.checked };
            }
            return email;
        });

        // Update the state with the new email list
        setEmails(updatedEmails);

        // Filter to get the emails that are currently checked
        const selectedEmails = updatedEmails.filter(email => email.checked);

        // Set dataToDelete with the list of selected emails
        setSelectedEmails(selectedEmails)
        setDataToDelete(selectedEmails)
    };

    const onCloseVisiblePopup = () => {
        setVisible(false);
        setFormData({})
        setErrors({
            external_email: "",
            external_user_name: ""

        })
    };

    const onCloseDialogOpen = () => {
        setErrors({
            external_email: "",
            external_user_name: ""

        })
        setIsDialogOpen(false);
    };

    const renderFooter = (a) => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={onCloseVisiblePopup} />
                    <ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit} />
                </div>
            </div>
        );
    }

    const renderEditFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={onCloseDialogOpen} />
                    <ButtonElement type="submit" label="Update" className="save-button" onClick={handleEditSubmit} />
                </div>
            </div>
        );
    }

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false)
        // window.location.reload()
    }

    const deleteProductDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
                </div>
            </div>
        );
    }

    const deleteField = async () => {
        setDeleteProductDialog(false);
        try {
            setLoading(true)
            const response = await removeExternalUser(dataToDelete);
            if (response && response.data.success) {
                getExternalEmail();
                toastRef.current.showToast({
                    type: 'success',
                    message: "User(s) deleted successfully"
                })
            }
            else {
                toastRef.current.showToast({
                    type: 'error',
                    message: response.data.message
                })
            }

        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
        finally {
            setLoading(false);
            getExternalEmail();
            setDataToDelete([])
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            if (Object.entries(errors).some(([key, value]) => value !== '')) {
                return;
            }
            else {
                const emailResponse = await checkEmail(customerId, formData);
                const emailDataFromResponse = emailResponse?.data?.surveyEmailData;
                setSurveyEmailData(emailDataFromResponse);
                const emailCheck = _.find(emailDataFromResponse, { customer_id: emailResponse?.data?.cus_id, external_email: formData.external_email });
                if (formData.external_user_name === "" || formData.external_user_name === undefined) {
                    toastRef.current.showToast({
                        type: 'error',
                        message: "Please enter username"
                    })
                } else {
                    if (formData.external_email === "" || formData.external_email === undefined) {
                        toastRef.current.showToast({
                            type: 'error',
                            message: "Please enter valid email id"
                        })
                    } else {
                        if (_.isEmpty(emailCheck)) {
                            const saveResponse = await saveEmail(customerId, formData);
                            if (saveResponse && saveResponse.data.success) {
                                setFormData({});
                                setErrors({
                                    external_email: "",
                                    external_user_name: ""

                                })
                                toastRef.current.showToast({
                                    type: 'success',
                                    message: saveResponse.data.message
                                })
                            } else {
                                toastRef.current.showToast({
                                    type: 'error',
                                    message: saveResponse.data.message
                                })
                            }
                            setVisible(false);
                        } else {
                            toastRef.current.showToast({
                                type: 'error',
                                message: "Email id already exists"
                            })
                        }
                    }
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
            getExternalEmail();
        }
    }

    const handleEditSubmit = async () => {
        try {
            setLoading(true)
            if (Object.entries(errors).some(([key, value]) => value !== '')) {
                return;
            }
            else {
                //Check the email
                const checkEmailResponse = await checkEmail(customerId, selectedEmail);
                const surveyEmailDataEdit = checkEmailResponse?.data?.surveyEmailData;

                //Validate email
                const emailCheck = surveyEmailDataEdit.find(
                    (item) => item.external_email === selectedEmail.external_email
                );
                if (!emailCheck) {
                    //Update external user if valid
                    const updateResponse = await updateExternalUser(selectedEmail);
                    if (updateResponse && updateResponse.data.success) {
                        setSelectedEmail({})
                        setErrors({
                            external_email: "",
                            external_user_name: ""

                        })
                        onCloseDialogOpen();
                        toastRef.current.showToast({
                            type: 'success',
                            message: "User updated successfully"
                        })
                    } else {
                        toastRef.current.showToast({
                            type: 'error',
                            message: updateResponse.data.message
                        })
                    }
                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: "Email id already exists"
                    })
                }
            }

        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: "An error occurred"
            })
        } finally {
            setLoading(false)
            getExternalEmail();
        }

    };


    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col pr-0 pl-0">
                    <p className="label-text">
                        {controlPanelEmailsTab}
                    </p>
                </div>
            </div>
            <div className="group-table-buttons">
                <div className="delete-button">
                    {selectedEmails?.length > 0 && (
                        <ButtonElement
                            className="delete-button-icon"
                            type="button"
                            icon="pi pi-trash"
                            onClick={confirmDeleteProduct}
                        />
                    )}
                </div>
                <div className="group-table-search">
                    <HeaderSearchBar
                        value={searchQuery}
                        onChange={(e) => handleSearchChange(e)}
                        onClick={handleClearFilter}
                    />
                    <ButtonElement
                        className="clear-filter-button"
                        type="button"
                        icon="pi pi-plus"
                        label="New"
                        onClick={() => show("right")}
                    />
                </div>
            </div>
            <div className="data-submit">
                {
                    <div className="group-table-data">
                        <table className="group-datatable">
                            <thead className="group-table-header">
                                <tr>
                                    <th colSpan={4}>{_.find(controlEmailTables, { table_name: "External Emails" })?.display_name}</th>
                                </tr>
                                <tr>
                                    <th className="checkbox-header width-2"></th>
                                    <th className="w-30">{_.find(controlPannelEmailsHeaders, { header_name: "User Name" })?.display_name}</th>
                                    <th className="w-30">{_.find(controlPannelEmailsHeaders, { header_name: "Email" })?.display_name}</th>
                                    <th>{_.find(controlPannelEmailsHeaders, { header_name: "Action" })?.display_name}</th>
                                </tr>
                            </thead>
                            <tbody className="group-table-row stakeplan">
                                <React.Fragment>
                                    {
                                        emails?.map((sub, ind) => (
                                            <tr key={sub._id}>
                                                <td>
                                                    <CheckboxElement
                                                        id={`sub-${ind}`}
                                                        name={`sub-${ind}`}
                                                        checked={sub.checked || false}
                                                        onChangeCheck={() => handleCheckboxChange(ind, sub)}
                                                        className="mr-2"
                                                    />
                                                </td>
                                                <td className='width-10'>
                                                    <div>{sub.external_user_name}</div>

                                                </td>
                                                <td className='width-10'>
                                                    <div>{sub.external_email}</div>

                                                </td>
                                                <td className='width-10'>
                                                    <InputIcon
                                                        className="pi pi-pencil ml-10"
                                                        onClick={() => openEmailEdit(true, ind, sub)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                </React.Fragment>
                            </tbody>
                        </table>
                    </div>
                }
            </div>
            <Dialog
                header={"Add"}
                visible={visible}
                position="right"
                className="width-50vw"
                onHide={onCloseVisiblePopup}
                footer={renderFooter()}
                draggable={false}
            >
                <div className="new-field">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                    {_.find(controlPannelEmailsHeaders, { header_name: "User Name" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <InputTextElementElement
                                    id="external_user_name"
                                    value={formData?.external_user_name}
                                    onChange={(e) => handleInputChange("external_user_name", e.target.value)}
                                    required
                                    className="w-full"
                                    placeholder="text"
                                />
                                {errors.external_user_name && (
                                    <small className="text-danger">
                                        {errors.external_user_name}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                    {_.find(controlPannelEmailsHeaders, { header_name: "Email" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <InputTextElementElement
                                    id="external_email"
                                    value={formData?.external_email}
                                    onChange={(e) => handleInputChange("external_email", e.target.value)}
                                    required
                                    placeholder="email"
                                    className="w-full"
                                />
                                {errors.external_email && (
                                    <small className="text-danger">
                                        {errors.external_email}
                                    </small>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </Dialog>
            <Dialog
                header={"Edit"}
                visible={isDialogOpen}
                position="right"
                className="width-50vw"
                onHide={onCloseDialogOpen}
                footer={renderEditFooter()}
                draggable={false}
            >
                <div className="new-field">
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className="col-md-4 pl-0">
                            <label className="form-label text-left">
                                {_.find(controlPannelEmailsHeaders, { header_name: "User Name" })?.display_name}:
                            </label>
                        </div>
                        <div className="col pr-0">
                            <InputTextElementElement
                                id="external_user_name"
                                value={selectedEmail?.external_user_name}
                                onChange={(e) => handleEditInputChange("external_user_name", e.target.value)}
                                required
                                className="w-full"
                                placeholder="text"
                            />
                            {errors.external_user_name && (
                                <small className="text-danger">
                                    {errors.external_user_name}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className="col-md-4 pl-0">
                            <label className="form-label text-left">
                                {_.find(controlPannelEmailsHeaders, { header_name: "Email" })?.display_name}:
                            </label>
                        </div>
                        <div className="col pr-0">
                            <InputTextElementElement
                                id="external_email"
                                value={selectedEmail?.external_email}
                                onChange={(e) => handleEditInputChange("external_email", e.target.value)}
                                required
                                placeholder="email"
                                className="w-full"
                            />
                            {errors.external_email && (
                                <small className="text-danger">
                                    {errors.external_email}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog
                visible={deleteProductDialog}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Confirm Delete"
                modal
                footer={deleteProductDialogFooter}
                onHide={hideDeleteProductDialog}
                className="table-dialog width-32"
                draggable={false}
            >
                <div className="confirmation-content">
                    {dataToDelete && (
                        <span>
                            {dataToDelete.length > 1 ? (
                                <span className="table-description">
                                    Do you want to remove the users{" "}
                                    {/* {dataToDelete.map((item, index) => (
                                        <b key={index}>{item.external_user_name}{index < dataToDelete.length - 1 ? ', ' : ''}</b>
                                    ))} */}
                                    ?
                                </span>
                            ) : (
                                <span className="table-description">
                                    Do you want to remove the user{" "}
                                    {/* <b>{dataToDelete[0]?.external_user_name}</b> */}
                                    ?
                                </span>
                            )}
                        </span>
                    )}
                </div>
            </Dialog>
        </div>
    )
}

export default ExternalEmails;
